import {
  Button,
  ResourceComponentProps,
  SelectInput,
  useDataProvider,
  useNotify,
  useRecordContext,
  useRefresh,
} from "react-admin";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField as MuiTextField
} from "@material-ui/core";
import { useEffect, useState } from "react";
import { Form, Field } from 'react-final-form';
import { CustomDataProvider } from "../../../../network/DataProvider";
import { MachineDefinitionGroup } from "./models";

export const MachineDefinitionTelemetryGroupCreate = (props: ResourceComponentProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const dataProvider = useDataProvider<CustomDataProvider>();
  const record = useRecordContext();
  const refresh= useRefresh();
  const notify = useNotify();

  const [groups, setGroups] = useState<MachineDefinitionGroup[]>([]);

  useEffect(() => {
    // @ts-ignore
    dataProvider.getMachineGroups(props.id)
      .then(({ data }) => {
        setGroups(data);
      })
    // @ts-ignore
  }, [props.id, dataProvider]);

  const handleDialogClose = () => {
    setIsOpen(false);
  };

  const handleSubmit = async (
    values: any
  ) => {
    try {
      await dataProvider.createMachineGroup(record.id, { name: values.name, parentId: values.parentId });
      refresh();
      setIsOpen(false);
      notify("MachineGroup created", { type: "info" });
    } catch (error) {
      notify("Error creating MachineGroup", { type: "error" });
    }
  };

  const validate = (values: any) => {
    const errors: Record<string, string> = {};
    if (!values.name || values.name.trim() === '') {
      errors.name = 'Name is required';
    }
    return errors;
  };

  return (
    <Box display="flex" flexDirection="row" justifyContent={"right"}>
      <Button
        label="ra.action.create"
        onClick={() => setIsOpen(true)}
      />
      <Dialog
        open={isOpen}
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>Create Group</DialogTitle>
        <DialogContent>
          <Form
            onSubmit={handleSubmit}
            validate={validate}
            render={({ handleSubmit, submitting, pristine }) => (
              <form onSubmit={handleSubmit}>
                <Field name="name">
                  {({ input, meta }) => (
                    <MuiTextField
                      {...input}
                      label="Group Name"
                      variant={"filled"}
                      fullWidth
                      error={meta.touched && Boolean(meta.error)}
                      helperText={meta.touched && meta.error}
                    />
                  )}
                </Field>
                <SelectInput
                  source="parentId"
                  options={{ label: "Group" }}
                  allowEmpty
                  optionValue={"id"}
                  emptyText={"None"}
                  emptyValue={null}
                  choices={groups}
                  fullWidth
                />

                <DialogActions>
                  <Button
                    type="submit"
                    color="primary"
                    variant="contained"
                    label={"Create"}
                    disabled={submitting || pristine}
                  />
                </DialogActions>
              </form>
            )}
          />
        </DialogContent>
      </Dialog>
    </Box>
  )
}
